<template>
  <AppModal
    v-model="value"
    :header-name="$t('Invite user')"
    :footer-hide="false"
    @click:submit="submitForm"
    @click:cancel="cancel"
    width="350"
    :loading="loading"
    class="invite-modal"
  >
    <Form ref="inviteForm" :model="form" :rules="formRules" @submit.native.prevent="submitForm">
      <Row class="mt-3">
        <p>{{ $t("Email") }}</p>
        <FormItem prop="email">
          <Input type="text" v-model="form.email"></Input>
        </FormItem>
      </Row>
      <Row class="mt-3">
        <p>{{ $t("Role") }}</p>
        <FormItem prop="userRole">
          <Select v-model="form.userRole">
            <i-option
              v-for="invitableRole in userRoles"
              :key="invitableRole.code"
              :value="invitableRole.code"
            >
              {{ invitableRole.label }}
            </i-option>
          </Select>
        </FormItem>
      </Row>
      <Row class="mt-3">
        <p>{{ $t("Reference UID") }}</p>
        <FormItem prop="referenceUid">
          <Input type="text" v-model="form.referenceUid"></Input>
        </FormItem>
      </Row>
      <input type="submit" hidden /> <!-- FIXME: make clean Press Enter submit handling -->
    </Form>
  </AppModal>
</template>

<script>
import AppModal from "@/components/common/AppModal";
import {postInviteUserQry} from "@/services/auth.service";
import { buildRequiredRules } from "@/helpers/common.helper";

export default {
  name: "InviteUser",

  components: {
    AppModal,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    client: {
      required: true,
      type: Object
    },
    contract: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      form: {
        email: '',
        referenceUid: '',
        userRole: null,
      },
      loading: false,
      formRules: {}, // Autofilled in created()
    };
  },
  computed: {
    userRoles() {
      return this.getInvitableUserRoles()
    },
    defaultRole() {
      return this.s2ec.userRoles.traveler
    }
  },
  created() {
    this.form.userRole = this.defaultRole.code;
    this.formRules = buildRequiredRules(this.form);
    delete this.formRules["referenceUid"];  // Keep this one optional
  },
  methods: {
    cancel() {
      this.$emit("input", false);
      this.$refs["inviteForm"].resetFields()
    },
    submitForm(){
      const inviteFormElem = this.$refs.inviteForm
      inviteFormElem.validate( valid => {
        if (valid) this.triggerInviteUser()
      })
    },
    async triggerInviteUser() {
      const data = {
        email: this.form.email,
        client: this.client.id,
        contract: this.contract.id,
        user_role: this.form.userRole,
        reference_uid: this.form.referenceUid,
      }
      await postInviteUserQry(data)
        .then(() => {
          this.$Message.success((this.$t('Successfully invited') + ` ${data.email}`));
          this.$refs["inviteForm"].resetFields()
          this.cancel()
          this.$emit("refreshUsers")
        })
        .catch(err => {
          const error = err.response;
          if (error.data.non_field_errors && error.data.non_field_errors[0]) {
            this.$Message.error({content: error.data.non_field_errors[0], duration: 5})
          } else {
            this.$Message.error({content: this.$t('Error occurred inviting') + ` ${data.email}`, duration: 5})
          }
        })
    }
  },
};
</script>
